type Ret = {
  introPart: string;
  canvasPart: string;
  canvasIsStreaming: boolean;
  outroPart: string;
  buttonPart: string;
};

export const splitMessageIntoCanvasParts = (content: string): Ret => {
  /* 
  Part before "--start-canvas-markdown--" is the text parts.
  Part after "--end-canvas-markdown--" is text parts.
  Parts between "--start-canvas-markdown--" and "--end-canvas-markdown--" are canvas parts.
  Parts between "--start-action-button--" and "--end-action-button--" are button parts.
  */

  const hasStartDelimiter = content.includes("--start-canvas-markdown--");
  const hasEndDelimiter = content.includes("--end-canvas-markdown--");
  const hasButtonStart = content.includes("--start-action-button--");
  const hasButtonEnd = content.includes("--end-action-button--");

  // Extract button part if present
  let buttonPart = "";
  let contentWithoutButton = content;

  if (hasButtonStart && hasButtonEnd) {
    const buttonStartSplit = content.split("--start-action-button--");
    const buttonContent =
      buttonStartSplit[1]?.split("--end-action-button--")[0] || "";
    buttonPart = buttonContent.trim();

    // Remove button part from content for further processing
    contentWithoutButton = content
      .replace(/--start-action-button--.*?--end-action-button--/s, "")
      .trim();
  }

  // If no canvas delimiters, return entire content as intro part
  if (!hasStartDelimiter) {
    return {
      introPart: contentWithoutButton,
      canvasPart: "",
      canvasIsStreaming: false,
      outroPart: "",
      buttonPart,
    };
  }

  const startSplit = contentWithoutButton.split("--start-canvas-markdown--");
  const introPart = startSplit[0] || "";

  // Handle case where start delimiter exists but end delimiter doesn't
  if (!hasEndDelimiter) {
    const canvasPart = startSplit[1] || "";
    return {
      introPart,
      canvasPart,
      canvasIsStreaming: true,
      outroPart: "",
      buttonPart,
    };
  }

  // Both delimiters exist
  const canvasPart = startSplit[1]?.split("--end-canvas-markdown--")[0] || "";
  const outroPart =
    contentWithoutButton.split("--end-canvas-markdown--")[1] || "";

  return {
    introPart,
    canvasPart,
    canvasIsStreaming: false,
    outroPart,
    buttonPart,
  };
};
